var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg05(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 39 36.64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#000;stroke-miterlimit:10;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_2",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 2"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "0.5 3.65 0.5 29.65 19.5 32.65"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 0.5,
    y1: 33.15,
    x2: 19.5,
    y2: 36.15
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "19.5 29.65 4.5 25.65 4.5 0.65 19.5 4.65 19.5 29.65"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 17,
    y1: 22.85,
    x2: 7,
    y2: 20.19
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 17,
    y1: 16.85,
    x2: 7,
    y2: 14.19
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 17,
    y1: 9.85,
    x2: 7,
    y2: 7.19
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "38.5 3.65 38.5 29.65 19.5 32.65"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 38.5,
    y1: 33.15,
    x2: 19.5,
    y2: 36.15
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "19.5 29.65 34.5 25.65 34.5 0.65 19.5 4.65 19.5 29.65"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 22,
    y1: 22.85,
    x2: 32,
    y2: 20.19
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 22,
    y1: 16.85,
    x2: 32,
    y2: 14.19
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 22,
    y1: 9.85,
    x2: 32,
    y2: 7.19
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg05);
export default __webpack_public_path__ + "static/media/05.ff0b58617a7ba1fc2fb99e3984b09ba0.svg";
export { ForwardRef as ReactComponent };